import './CustomPacingAppliedCell.scss';

import type { SwitchChangeEventHandler } from 'antd/lib/switch';
import { User } from 'mission-control-common-components';
import { useState } from 'react';
import type { Row } from 'react-table';

import ModalPopup from '../../../../../common/ModalPopup';
import ToggleSwitch from '../../../../../common/ToggleSwitch';
import type { PermissionsNames } from '../../../../../constants';
import { useDeleteCustomPacings } from '../../../../../hooks/useDeleteCustomPacings';
import bem from '../../../../../utils/bem';
import type { LineItemModel } from '../../modelConverters';

type Props = {
  row: Row<LineItemModel>;
};

const [block] = bem('custom-pacing-applied-cell');

const CONFIRMATION_MESSAGE = 'Custom pacing schedule will be removed for the line item';
const CANCEL_BUTTON_LABEL = 'Cancel';
const CONFIRMATION_BUTTON_LABEL = 'Confirm';

const CustomPacingAppliedCell = ({ row }: Props): React.JSX.Element => {
  const permissions = User.getPermissions<PermissionsNames>();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { handleDelete, loading } = useDeleteCustomPacings();

  const handleOnChange: SwitchChangeEventHandler = async (_, event) => {
    event.stopPropagation();

    setIsModalVisible(true);
  };

  const handleConfirmDelete = async (): Promise<void> => {
    await handleDelete([row.original.id]);

    setIsModalVisible(false);
  };

  const handleCancel = (): void => {
    setIsModalVisible(false);
  };

  return (
    <div
      className={block()}
      onClick={(e): void => {
        e.stopPropagation();
      }}
    >
      <ToggleSwitch
        disabled={!row.original.customPacingApplied || loading || !permissions?.removeCustomPacing}
        isOn={!!row.original.customPacingApplied}
        onChange={handleOnChange}
      />
      <ModalPopup
        visible={isModalVisible}
        onCancel={handleCancel}
        onOk={handleConfirmDelete}
        modalProps={{
          title: CONFIRMATION_MESSAGE,
          cancelText: CANCEL_BUTTON_LABEL,
          okText: CONFIRMATION_BUTTON_LABEL,
          okButtonProps: {
            disabled: loading,
            loading: loading,
          },
        }}
      />
    </div>
  );
};

export default CustomPacingAppliedCell;
